import React, { useState, useEffect, useContext, useCallback, useMemo, memo } from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import {View, Dimensions, StyleSheet, TouchableOpacity, Keyboard, Text, KeyboardAvoidingView, Platform} from "react-native";
import Icon from 'react-native-vector-icons/FontAwesome';
import IonIcon from 'react-native-vector-icons/Ionicons';
import SaleScreen from "./SaleScreen";
import CartScreen from "./CartScreen";
import { CartContext } from '../helpers/CartContext';
import BigSaleScreen from './BigSaleScreen';
import SuccessModal from "./SuccessModal";
import {useNavigation, useRoute} from "@react-navigation/native";
import FailModal from "./FailModal";
import FunctionsScreen from "./FunctionsScreen";
import { TableContext } from "../helpers/TableContext";
import CircularButton from '../components/CircularButton';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { SystemContext } from "../helpers/SystemContext";
import { VipCardContext } from "../helpers/VipCardContext";
import { OnlineOrderContext } from "../helpers/OnlineOrderContext";
import OrdersScreen from "./OrdersScreen";
import { OrdersContext } from "../helpers/OrdersContext";
import StatisticsHelper from "../helpers/StatisticsHelper";
import { useTranslation } from 'react-i18next';
import '../../i18n';
import Observables from "@happy-gastro/global-observables";
import CustomTooltip from "../helpers/CustomTooltip";
import {TourContext} from "../helpers/TourContext";

const Tab = createBottomTabNavigator();
const { width } = Dimensions.get('window');

export default function HomeScreen({ }) {
    const { t } = useTranslation();
    const { currentTable, removeTable, selectTable } = useContext(TableContext);
    const { cartItems = [], paymentModalVisible = false, setCart = () => {}, setPaymentModalVisible = () => {}, setAlreadySentCartItems = () => {}, alreadySentCartItems = [], setDiscountsForWholeCart = () => {} } = useContext(CartContext) || {};
    const route = useRoute();
    const { setSelectedCategory, setSelectedEvent, fetchSystemData } = useContext(SystemContext);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [failModalVisible, setFailModalVisible] = useState(false);
    const [order, setOrder] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const { removeVipCard, removeEmployee } = useContext(VipCardContext);
    const { resetOnlineOrder } = useContext(OnlineOrderContext);
    const { orders } = useContext(OrdersContext);
    const { productsSum, statistics } = StatisticsHelper(orders);
    const navigation = useNavigation();
    const [restaurantPlace, setRestaurantPlace] = useState({ _id: '' });
    const { currentStep, endTour, nextStep } = useContext(TourContext);
    // Your existing state and context variables...
    const [isKeyboardVisible, setKeyboardVisible] = useState(false); // Add this state

    // Add this useEffect for keyboard listeners
    useEffect(() => {
        const keyboardDidShowListener = Keyboard.addListener(
            'keyboardDidShow',
            () => {
                setKeyboardVisible(true);
            }
        );

        const keyboardDidHideListener = Keyboard.addListener(
            'keyboardDidHide',
            () => {
                setKeyboardVisible(false);
            }
        );

        // Clean up listeners
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);

    const loggedIn = route.params?.loggedIn || false;

    useEffect(() => {
        const fetchRestaurantPlace = async () => {
            const restaurantPlaceStored = await AsyncStorage.getItem("restaurantPlace");
            if (restaurantPlaceStored) {
                setRestaurantPlace(JSON.parse(restaurantPlaceStored));
            }
        };
        fetchSystemData();
        fetchRestaurantPlace();
    }, [route]);


    useEffect(() => {
        if(loggedIn) {
            new Promise(() => setTimeout(() => Observables.call("fetchSystemData"), 1000));
        }
        if(route.params?.saleScreen && width > 768) navigation.navigate('BigSale', {...route.params});
        if(route.params?.saleScreen && width < 768) navigation.navigate('Cart', {...route.params});
    }, [navigation, route.params]);

    useEffect(() => {
        if (route.params?.userInfo) {
            setUserInfo(route.params.userInfo);
        }
    }, [route.params]);

    useEffect(() => {
        if (route.params?.paymentSuccess !== undefined) {
            if (route.params?.paymentSuccess === true) {
                setOrder(route?.params?.orderResponse)
                setSuccessModalVisible(true);
                setPaymentModalVisible(false);
                navigation.navigate('Sale');
            } else {
                setFailModalVisible(true);
                setPaymentModalVisible(false);
            }
        }
    }, [route.params]);

    useEffect(() => {
        if (route.params?.navigateToSale) {
            navigation.navigate('SaleScreen');
        }
    }, [route.params]);

    const handleCloseModal = useCallback(() => {
        setSuccessModalVisible(false);
        setFailModalVisible(false);
        navigation.setParams({ paymentSuccess: undefined });
    }, [navigation]);

    const getRemainingItems = useCallback((tableOrderItems, payedItems) => {
        // Create a copy of tableOrderItems to avoid mutating the original array
        const remainingItems = [...tableOrderItems];

        // Iterate through each payedItem
        payedItems.forEach(payedItem => {
            // Find the corresponding item in remainingItems
            const itemIndex = remainingItems.findIndex(item => item._id === payedItem._id);

            if (itemIndex !== -1) {
                // Reduce the amount in the corresponding item
                remainingItems[itemIndex].amount -= payedItem.amount;

                // If the amount becomes 0 or less, remove the item from the array
                if (remainingItems[itemIndex].amount <= 0) {
                    remainingItems.splice(itemIndex, 1);
                }
            }
        });

        return remainingItems;
    }, []);

    const handleCloseSuccessModal = useCallback(async () => {
        setSuccessModalVisible(false);
        setFailModalVisible(false);
        navigation.setParams({ paymentSuccess: undefined });
        Observables.call("reloadOrders");
        Observables.call("refreshOrders");
        if (currentTable) {
            const tableOrder = orders?.find(
                (order) =>
                    !order.storno &&
                    order.status !== "cancelled" &&
                    order.status !== "closed" &&
                    order.tableId === currentTable?._id
            );
            if(tableOrder?.items && tableOrder?.items.length > 0){
                //navigation.navigate('HomeScreen');
                //console.log("close params:", route?.params)
                fetchSystemData();
                removeVipCard();
                removeEmployee();
                resetOnlineOrder();

                setAlreadySentCartItems(tableOrder.items)

            }else{
                navigation.navigate('TablesScreen');
                removeTable();
                setAlreadySentCartItems([]);
                setSelectedCategory(null);
                setSelectedEvent(null);
                await AsyncStorage.removeItem('currentTable');
                setDiscountsForWholeCart({ amount: 0, percentage: 0 });
                removeVipCard();
                removeEmployee();
                fetchSystemData();
                resetOnlineOrder();
            }
        }else{
            removeTable();
            setAlreadySentCartItems([]);
            setSelectedCategory(null);
            setSelectedEvent(null);
            await AsyncStorage.removeItem('currentTable');
            setDiscountsForWholeCart({ amount: 0, percentage: 0 });
            removeVipCard();
            removeEmployee();
            resetOnlineOrder();
            fetchSystemData();
            resetOnlineOrder();
        }
    }, [
        currentTable, 
        orders, 
        navigation, 
        fetchSystemData, 
        removeVipCard, 
        removeEmployee, 
        resetOnlineOrder, 
        setAlreadySentCartItems, 
        removeTable, 
        setSelectedCategory, 
        setSelectedEvent, 
        setDiscountsForWholeCart
    ]);
    // Memoize the screen options to prevent unnecessary re-renders
    const screenOptions = useMemo(() => ({
        headerShown: false,
        // Use newer screenOptions API instead of deprecated tabBarOptions
        tabBarActiveTintColor: '#a26909',
        tabBarInactiveTintColor: '#575757',
        tabBarActiveBackgroundColor: '#f0f0f0',
        tabBarInactiveBackgroundColor: '#ffffff',
        tabBarShowLabel: true,
        tabBarLabelStyle: {
            fontSize: 14,
            fontWeight: 'bold',
        },
        tabBarStyle: {
            height: 70,
            backgroundColor: '#e0e0e0',
            paddingBottom: Platform.OS === 'ios' ? 20 : 0,
            display: isKeyboardVisible ? 'none' : 'flex' // This hides the tab bar when keyboard is visible
        },
        tabBarItemStyle: {
            paddingVertical: 10,
            height: 70,
        },
        // Improve animation performance
        animationEnabled: false,
    }), [isKeyboardVisible]);

    // Memoize tab icons to prevent recreation on each render
    const homeIcon = useCallback(({ color, size }) => <Icon name="home" color={color} size={size} />, []);
    const basketIcon = useCallback(({ color, size }) => <Icon name="shopping-basket" color={color} size={size} />, []);
    const bagIcon = useCallback(({ color, size }) => (
        <CustomTooltip
            isVisible={currentStep === 9}
            onNext={() => nextStep()}
            placement="top"
            module={"default"}
            onClose={endTour}
            wrapped={<IonIcon name="bag-sharp" color={color} size={size} />}
        />
    ), [currentStep, nextStep, endTour]);

    const serverIcon = useCallback(({ color, size }) => (
        <CustomTooltip
            isVisible={currentStep === 10}
            onNext={() => nextStep()}
            placement="top"
            module={"default"}
            onClose={endTour}
            wrapped={<Icon name="server" color={color} size={size} />}
        />
    ), [currentStep, nextStep, endTour]);

    const shownOrders = useMemo(() => 
        [...statistics.onlineOrders, ...statistics.unClosedTakeAwayOrders, ...statistics.dineInOrders]
            .filter(order => !order.storno || order.status !== 'closed' || order.status !== 'cancelled'),
        [statistics.onlineOrders, statistics.unClosedTakeAwayOrders, statistics.dineInOrders]
    );


    return (
        <KeyboardAvoidingView
            style={{ flex: 1 }}
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        >
            <View style={{ flex: 1, width: '100%', height: '100%', flexGrow: 1 }}>
                <Tab.Navigator
                    initialRouteName="Sale"
                    detachInactiveScreens={true} // Changed to true for better performance
                    tabBarLabelPosition={"below-icon"}
                    lazy={true} // Changed to true for better initial load performance
                    backBehavior={"firstRoute"}
                    swipeEnabled={false} // Disable swipe for better performance
                    screenOptions={screenOptions}
                >
                    {width < 768 ? (
                        <>
                            <Tab.Screen name="Sale" component={SaleScreen}
                                        options={{
                                            tabBarIcon: homeIcon,
                                            title: t('sales'),
                                            tabBarLabel: t('sales'),
                                        }} />
                            <Tab.Screen name="Cart" component={CartScreen}
                                        options={{
                                            tabBarIcon: basketIcon,
                                            title: t('cart'),
                                            tabBarLabel: t('cart'),
                                            ...((cartItems.length > 0) && { 
                                                tabBarBadge: cartItems.length || 0,
                                                tabBarBadgeStyle: { 
                                                    minWidth: "fit-content", 
                                                    height: "fit-content", 
                                                    borderRadius: 14, 
                                                    justifyContent: 'center', 
                                                    alignItems: 'center', 
                                                    overflow: "show" 
                                                }
                                            }),
                                        }} />
                        </>
                    ) : (
                        <Tab.Screen name="BigSale" component={BigSaleScreen}
                                    options={{
                                            tabBarIcon: homeIcon,
                                            title: t('sales'),
                                            tabBarLabel: t('sales'),
                                            numColumns: 3,
                                    }} />
                    )}

                    {/* Memoize the badge count calculation */}
                    {useMemo(() => {
                        const ordersBadgeCount = shownOrders?.filter(order => order.restaurantPlace === restaurantPlace?._id)?.length || 0;
                        const ordersBadgeStyle = ordersBadgeCount === 0 
                            ? { display: 'none' } 
                            : { minWidth: "fit-content", height: "fit-content", borderRadius: 14, justifyContent: 'center', alignItems: 'center', overflow: "show" };

                        return (
                            <Tab.Screen name="HomeOrdersList" component={OrdersScreen}
                                options={{
                                    tabBarIcon: bagIcon,
                                    title: t('open_orders'),
                                    tabBarLabel: t('open_orders'),
                                    tabBarBadge: ordersBadgeCount,
                                    tabBarBadgeStyle: ordersBadgeStyle
                                }}
                                initialParams={{ name: "OrdersList" }}
                            />
                        );
                    }, [shownOrders, restaurantPlace?._id, t, bagIcon])}

                    <Tab.Screen name="Functions" component={FunctionsScreen}
                                options={{
                                    tabBarIcon: serverIcon,
                                    title: t('functions'),
                                    tabBarLabel: t('functions'),
                                }} />
                </Tab.Navigator>
                {!isKeyboardVisible && (
                    <CustomTooltip
                        isVisible={currentStep === 11}
                        onNext={()=> {
                            setCart([])
                            endTour();
                        }}
                        bottomMargin={80}
                        placement="top"
                        module={"default"}
                        onClose={endTour}
                        wrapped={<CircularButton navigation={navigation} iconName="grid" />}
                    />
                )}


                <SuccessModal visible={successModalVisible} order={order} onClose={handleCloseSuccessModal} />
                <FailModal visible={failModalVisible} onClose={handleCloseModal} />
            </View>
        </KeyboardAvoidingView>
    );
}

const styles = StyleSheet.create({
    background: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
